<template>
  <div class="slideout-container">
    <div class="heat-sheild" v-show="isOpen"></div>
    <transition name="slide-out-transition">
      <div class="slide-out slideLeft" v-if="isOpen">
        <div class="close-wrapper" @click="isOpen = false">
          <a>&times;</a>
        </div>
        <component @closeSlideout="isOpen = false" :is="currentSlideout" v-bind="dynamicProps" @packageCompareToggled="packageCompareToggled"></component>
      </div>
    </transition>
  </div>
</template>

<script>
import packagesCompare from './compare-packages'
import leadManager from './lead-form/lead-manager'

export default {
  name: 'slide-out',
  components: {
    packagesCompare: packagesCompare,
    leadManager
  },
  watch: {
    isOpen: function(newVal) {
      var rootElement = document.getElementsByTagName('html')[0]
      if (newVal) {
        rootElement.style.overflow = 'hidden'
      } else {
        rootElement.style.overflow = ''
      }
    }
  },
  props: ['dynamicProps', 'currentSlideout'],
  data() {
    return {
      currentComponent: null,
      isOpen: false
    }
  },
  computed: {
    dynamicComponentProps: function() {
      if (this.currentSlideout === 'package') {
        return {
          pkg: this.dynamicProps
        }
      }
    }
  },
  methods: {
    showSlideout: function() {
      this.isOpen = true
    },
    packageCompareToggled: function() {
      this.$emit('packageCompareToggled')
    }
  }
}
</script>

<style>
.close-wrapper {
  transform: translateX(-50px);
}

.close-button {
  height: 30px;
  width: 30px;
  background-color: black;
  position: absolute;
}

.heat-sheild {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.6;
  z-index: 10001;
}

.slide-out {
  position: fixed;
  height: 100%;
  background-color: white;
  right: 0px;
  top: 0px;
  overflow: auto;
  overflow-x: hidden;
  z-index: 10001;
  padding-left:50px;
  background-clip:content-box;
}

.slide-out-transition-enter-active,
.slide-out-transition-leave-active {
  transition: all 0.3s ease;
}

.slide-out-transition-enter,
.slide-out-transition-leave-to {
  transform: translateX(100%);
}
</style>



// WEBPACK FOOTER //
// src/components/slide-out.vue